import React from 'react';
import { Button } from 'antd';
import { useNotificationListTemplate } from 'hooks/notification/notificationList';
import SPButton from "../../../carRental/base/SPButton";
import emiter, {_EVENTS } from '../../../../events'


interface IComponentProps {
  data?: any;
  permission?: any;
}
const SPTableActionBar: React.FC<IComponentProps> = (props) => {
  const { data, permission } = props

  const { tableActionEdit, tableActionView,update ,searchByData  } = useNotificationListTemplate();


  const onView = () => {
    update(data).then(() => {
      tableActionView(data);
      searchByData()
      data.channel == 5 && emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.TOPMSG);
    });
  };

    return (
    <>
        <SPButton permissionKey='show-message-detail' permission={permission} type="link" onClick={onView}>查看</SPButton>
    </>
  );
};

export default SPTableActionBar;
